const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://m4qdpim4j9.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://vdo6l2no17.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.barrick.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.staging.barrick.forwoodsafety.com'
  }
};

export default config;